module.exports = __webpack_public_path__ + "static/img/people.90677f6e.svg";